import { AbstractControl, ValidationErrors } from '@angular/forms';

export function minDateValidator(minDate: Date) {
	return (control: AbstractControl): ValidationErrors | null => {
		if (!control.value) return null;

		const valueDate = new Date(control.value);
		return valueDate < minDate ? { minDate: { min: minDate } } : null;
	};
}
